import { render } from "./NavBarwice.vue?vue&type=template&id=c34c029e&scoped=true"
import script from "./NavBarwice.vue?vue&type=script&lang=js"
export * from "./NavBarwice.vue?vue&type=script&lang=js"

import "./NavBarwice.vue?vue&type=style&index=0&id=c34c029e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c34c029e"]])

export default __exports__